import styled from 'styled-components';
export const Popover = styled.div`
  position: absolute;
  overflow-y: auto;
  width: 100%;
  background: #fff;
  z-index: 10;
  box-shadow: 0px 5px 10px rgba(53, 60, 96, 0.15);
  border-radius: 4px;
  margin: 3px 0;
  ${props => props.height && `height: ${props.height}px;`}
  ${props => props.bottom && `bottom: ${props.bottom}px;`}
`;
export const Suggestion = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: transparent;
  ${props => props.hover && 'background: rgba(53, 59, 96, 0.05);'}
  ${props => props.active && 'background: rgba(92, 130, 229, 0.15);'}
  ${props => props.active && props.hover && 'background: linear-gradient(rgba(53, 59, 96, 0.05), rgba(53, 59, 96, 0.05)), linear-gradient(rgba(92, 130, 229, 0.15), rgba(92, 130, 229, 0.15));'}
  cursor: pointer;
  color: #353b60;
  font-weight: 500;
  font-size: 14px;
  padding: 10px 8px 10px 12px;
  line-height: 21px;
`;